import React from "react";
import HomeMarquee from "../components/app/home/HomeMarquee";
import Journey from "../components/app/about/Journey";
import FindJobLayout from "../components/app/layout/FindJobLayout";
import Achivements from "../components/app/about/Achivements";
import Social, { ISocials } from "../components/app/common/Socials";
import { BlurFade } from "../components/app/BlurFade";
import AboutMarquee from "../components/app/about/AboutMarquee";
import EarlyAccess from "../components/app/common/EarlyAccess";

const AboutusPage: React.FC = () => {
  const socialImages: string[] = [
    "/learning/socials/social-1.png",
    "/learning/socials/social-2.png",
    "/learning/socials/social-3.png",
    "/learning/socials/social-4.png",
    "/learning/socials/social-5.png",
  ];

  const socialLinks: ISocials[] = [
    {
      url: "/socials/social-facebook.svg",
      name: "Facebook",
      link: "https://www.facebook.com/share/1Biim3dQjF/?mibextid=wwXIfr",
    },
    {
      url: "/socials/social-instagram.svg",
      name: "Instagram",
      link: "https://www.instagram.com/dream_weaversg/",
    },
  ];
  return (
    <div>
      <section
        className="min-h-[80vh] sm:min-h-[100vh] flex p-5 lg:px-10 xl:px-16 items-center pt-[6rem] md:pt-0"
        style={{
          backgroundImage: "url(/home-hero.svg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <BlurFade delay={0.25} inView>
          <div className="grid md:grid-cols-2 gap-5 pl-5 w-full">
            <div className="flex flex-col items-center justify-center gap-3">
              <h3 className="text-white text-2xl md:text-3xl transition-all duration-150 ease-out lg:text-5xl xl:text-6xl xl:pb-4 w-full max-w-5xl font-light">
                Our Mission
              </h3>
              <p className="text-white text-sm lg:text-lg xl:text-2xl leading-normal font-light w-full">
                At Dream Weavers, our mission is to empower individuals and
                organizations through innovative learning solutions, skill
                development programs, and transformative training initiatives.
                We are committed to creating a positive impact across industries
                by fostering growth, excellence, and lifelong learning. Through
                technology-driven education, collaborative partnerships, and a
                passion for shaping the future, we aim to bridge skill gaps,
                enhance careers, and contribute to a more skilled and
                knowledgeable world.
              </p>
            </div>
            <div className="flex md:justify-end justify-center items-center lg:pr-8 xl:pr-10 xl:pt-7">
              <img
                src="/aboutus/about-hero.png"
                alt=""
                className="h-56 md:h-[20rem] lg:h-[22rem] xl:h-[28rem] hover:scale-105 transition-all duration-200 ease-out"
              />
            </div>
          </div>
        </BlurFade>
      </section>
      <BlurFade delay={0.25} inView>
        <section className="-mt-[2rem] sm:-mt-[6rem] md:-mt[8rem]">
          <HomeMarquee className="h-24 sm:h-32" />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="my-8 lg:my-12 xl:my-20">
          <Journey />
        </section>
      </BlurFade>
      <section>
        <AboutMarquee className="h-24 sm:h-32" />
      </section>
      <BlurFade delay={0.25} inView>
        <section className="py-5 sm:py-7 lg:py-16 xl:px-14">
          {/* achivement and certifications */}
          <Achivements />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section>
          {/* todo: add button url here in future when available */}
          <FindJobLayout
            title="Dream Weavers Leadership"
            description="Success starts with leadership—guided by core values, driven by excellence, and inspired to lead by example."
            buttonContent="View our Leadership Team"
            buttonUrl="/company"
            underlineUrl="/careers"
          />
        </section>
      </BlurFade>
      <section>
        <Social socialLinks={socialLinks} images={socialImages} />
      </section>
      <section
        className="px-5 sm:px-10 mt-10"
        style={{
          backgroundImage: "url('/home/early-access-bg.svg')",
        }}
      >
        <EarlyAccess />
      </section>
    </div>
  );
};
export default AboutusPage;
